import { Component, Input, Output, EventEmitter } from '@angular/core';
import { SelectItem } from 'primeng/api';

@Component({
  selector: 'app-operation-envelope-toolbar',
  templateUrl: './operation-envelope-toolbar.component.html',
  standalone: false
})
export class OperationEnvelopeToolbarComponent {
  @Input() public singleMultiple: SelectItem[] = [];
  @Input() public resultsDisplay: SelectItem[] = [];
  @Input() public envelopeOperation: SelectItem[] = [];

  @Input() public selectedSingleMultiple = 'singleOperation';
  @Input() public selectedResultsDisplay = 'plot';
  @Input() public selectedEnvelopeOperation = 'phaseEnvelope';

  @Input() public phaseEnvelopes: any[] = [];
  @Input() public selectedPhaseEnvelope: any;

  @Input() public operations: any[] = [];
  @Input() public selectedOperation: any;

  @Input() public moveUpDisabled = true;
  @Input() public moveDownDisabled = false;

  @Output() public modeChanged = new EventEmitter<string>();
  @Output() public phaseEnvelopeChanged = new EventEmitter<any>();
  @Output() public resultsDisplayChanged = new EventEmitter<string>();
  @Output() public envelopeOperationChanged = new EventEmitter<string>();
  @Output() public operationChanged = new EventEmitter<any>();
  @Output() public moveRequested = new EventEmitter<'up' | 'down'>();

  public onModeChanged(mode: string): void {
    this.modeChanged.emit(mode);
  }

  public onPhaseEnvelopeChanged(value: any): void {
    this.phaseEnvelopeChanged.emit(value);
  }

  public onResultsDisplayChanged(value: string): void {
    this.resultsDisplayChanged.emit(value);
  }

  public onEnvelopeOperationChanged(value: string): void {
    this.envelopeOperationChanged.emit(value);
  }

  public onOperationChanged(value: any): void {
    this.operationChanged.emit(value);
  }

  public onMoveRequested(direction: 'up' | 'down'): void {
    this.moveRequested.emit(direction);
  }
}
